import { render, staticRenderFns } from "./scenario-compare-table.vue?vue&type=template&id=646421e8&scoped=true"
import script from "./scenario-compare-table.vue?vue&type=script&lang=ts"
export * from "./scenario-compare-table.vue?vue&type=script&lang=ts"
import style0 from "./scenario-compare-table.vue?vue&type=style&index=0&id=646421e8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646421e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('646421e8')) {
      api.createRecord('646421e8', component.options)
    } else {
      api.reload('646421e8', component.options)
    }
    module.hot.accept("./scenario-compare-table.vue?vue&type=template&id=646421e8&scoped=true", function () {
      api.rerender('646421e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/results/scenario-compare/sections/scenario-compare-table.vue"
export default component.exports